import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UserVideoComponent } from '../../../user/user-video/user-video.component';
import { MessageService } from '../../../service/message/message.service';
import { WharehouseExit2Component } from '../../../wharehouse-reception/wharehouse-exit2/wharehouse-exit2.component';
import { RepairmanInvoiceFilterComponent } from '../repairman-invoice-filter/repairman-invoice-filter.component';

@Component({
  selector: 'app-repairman-invoice-list',
  templateUrl: './repairman-invoice-list.component.html',
  styleUrls: ['./repairman-invoice-list.component.scss']
})
export class RepairmanInvoiceListComponent implements OnInit, OnDestroy {
  //**********************************************************
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public show_excel: boolean = false;
  public indeterminate: boolean = false;
  public checked: boolean = false;
  public asc_desc: string = 'asc';
  public count_total: number = 1;
  public excel: number = 1;
  public page: number = 1;
  public list_record: any = [];
  public search_array: any = [];
  public selected_record: any = [];
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  public site!: string;
  public task_type!: number;
  public confirm_delete!: boolean;
  public user_id!: number;
  public page_number_first!: number;
  public page_number_second!: number;
  public code!: any;
  public order!: string;
  public export_code!: string;
  public type_task!: number;
  public search_all!: string;
  public id!: number;
  public pre_status!: boolean;
  public next_status!: boolean;
  public new_status!: boolean;
  public creator!: number;
  public video!: string;
  public access_service!: number;
  public level!: number;
  public sum_material!: number;
  public sum_service!: number;
  public sum_costs!: number;
  public sum_profit!: number;
  public sum_commission!: number;
  public sum!: number;
  public sum_discount!: number;
  public path_export!: string;
  public mat_table_selectedRow1: any;
  public mat_table_hoverRow!: any;
  public dataSource!: any;
  public displayedColumns = ['row', 'date', 'title', 'reception_id', 'model', 'invoice', 'sum', 'sum_material', 'sum_service', 'sum_costs', 'commission', 'profit', 'discount'];
  //************** */
  constructor(
    public serverService: ServerService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public messageService: MessageService,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    this.site = this.serverService.get_site();
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
      }
    )
    this.serverService.status1(2);
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.check_access(4, 1, 0, 1, 1);
    //**************
  }//end ngOnInit

  //****************************************************************************
  check_access(type_task: any, page: number, id: any, excel: number, loading: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, type: 'user', user_id: this.user_id, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.path_export = res['path_export'];
          this.access_service = res['result'][0].count;
          this.check_access2(type_task, page, id, excel, loading, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access2(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, page: number, id: any, excel: number, loading: number, access_service: number): any {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { 'address': 6, user_id: this.creator, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.video = res['result'][0].video;
          this.loading = false;
          if (type_task == 3) {
          }
          if (type_task == 4) { this.load_data(page, excel, loading, -1); }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  sort(sort: string, asc_desc: string) {
    if (asc_desc == 'asc') this.asc_desc = 'desc';
    else this.asc_desc = 'asc';
    this.order = sort + " " + this.asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  reset_sort(sort: string, asc_desc: string) {
    this.order = sort + " " + asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  load_data(page: number, excel: number, loading: number, changedRows: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5 || page == 1) { this.page = 1; }
    if (page == 6) { this.page = 1; }
    var obj = {
      'address': 7107,
      "page": this.page,
      'excel': excel,
      'user_id': this.user_id,
      'search': this.search_array,
      'search_all': this.search_all,
      'creator': this.creator,
      'changedRows': changedRows,
      'path_export': this.path_export,
      'order': this.order,
      'level': this.level
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (excel == 1) {
            if (changedRows == -1) this.list_record = [];
            if (changedRows > 0 || changedRows == -1) {
              for (var i = 0; i < res['num']; i++) {
                this.list_record.push(res['result'][i]);
              }//end for
            }
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.sum_material = res['sum_material'];
            this.sum_service = res['sum_service'];
            this.sum_costs = res['sum_costs'];
            this.sum_discount = res['sum_discount'];
            this.sum_profit = res['sum_profit'];
            this.sum_commission = res['sum_commission'];
            this.sum = res['sum'];
            this.pages(0);
            this.serverService.change_window_resize(2, '', 0);
            this.serverService.send_services_id(this.code);
          }
          else if (excel == 2) {
            this.export_excel(res['export_code']);
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20 || (this.page * 20 >= this.count_total)) {
      this.page_number_second = this.count_total;
      this.next_status = true;
    }//end if
    else { this.next_status = false; }
  }
  export_excel(code: number) {
    if (code > 0) {
      var x = <any>document.getElementById("excel");
      x.href = this.site + "/export/" + code + ".xlsx";
      x.click();
    }
  }
  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code }
    })
  }
  //***************************************************************************
  open_filter() {
    const dialogRef = this.dialog.open(RepairmanInvoiceFilterComponent, {
      width: '30rem',
      height: 'auto',
      disableClose: true,
      data: {
        search_array: this.search_array,
        code: this.code,
        creator: this.creator,
        type_task: 3
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.search_array = [];
          this.search_array = res;
          this.check_access(4, 1, 0, 1, 1);
        }
      }
    )
  }
  open_exit(i: number, id: number) {
    const dialogref = this.dialog.open(WharehouseExit2Component, {
      'width': '85rem',
      'height': 'auto',
      data: { 'reception_id': id, ref: 'exit', type: 2, code: this.code, creator: this.creator, level: this.level }
    });
    dialogref.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.list_record[i].repairman_reception_invoice_sum = res.result.repairman_reception_invoice_sum;
          this.list_record[i].repairman_reception_invoice_sum_material = res.result.repairman_reception_invoice_sum_material;
          this.list_record[i].repairman_reception_invoice_sum_service = res.result.repairman_reception_invoice_sum_service;
          this.list_record[i].repairman_reception_invoice_sum_costs = res.result.repairman_reception_invoice_sum_costs;
          this.list_record[i].repairman_reception_invoice_count = res.result.repairman_reception_invoice_count;
          this.list_record[i].repairman_reception_invoice_count_material = res.result.repairman_reception_invoice_count_material;
          this.list_record[i].repairman_reception_invoice_count_service = res.result.repairman_reception_invoice_count_service;
          this.list_record[i].repairman_reception_invoice_count_costs = res.result.repairman_reception_invoice_count_costs;
          this.list_record[i].repairman_reception_invoice_discount = res.result.repairman_reception_invoice_discount;
          this.list_record[i].repairman_reception_invoice_discount_service = res.result.repairman_reception_invoice_discount_service;
          this.list_record[i].repairman_reception_invoice_discount_material = res.result.repairman_reception_invoice_discount_material;
          this.list_record[i].repairman_reception_invoice_commission = res.result.repairman_reception_invoice_commission;
        }
      }
    )
  }
  get_bg(id: number) {
    this.id = id;
  }
  //*******************************************************************************
  change_resize() {
    //this.serverService.change_window_resize(1,'',0);
  }//end change_resize
  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 3000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}